module.exports = __webpack_public_path__ + "img/00.efe52a29.svg";